import {toggleGuide} from "../lib/common/guide";

toggleGuide('#toggleGuide', '.guide-wrap', 'collapsed');
toggleGuide('#toggleSidebar', '#sidebar', 'isCollapsed');
